<template>
    <div class="mt-4">
        <div class="col-12 mt-16">
            <div class="top-layers-container mb-4">
                <h2>Area Calculator</h2>
                <div class="hint">
                    <!-- Drag and drop layers, or use the arrows, to move them between the
                    Other Layers and Subtracted Layers. The
                    areas in Subtracted Layers will be subtracted from the total in Other Layers -->
                    Drag and drop layers, or use the arrows, to move them into the Subtracted Layers section
                </div>
            </div>
            <h3>
                Other Layers <span class="headers-sum-text">(Sum: {{ baseLayersSum }}) </span>


            </h3>
            <draggable class="list-group" :list="baseLayers" group="people" delayOnTouchOnly="true" delay="50"
                @change="log">
                <div v-for="(element, index) in baseLayers" :key="element.name">
                    <div :class="getClass(element)">
                        <div class="layer">
                            <v-icon class="pr-2">mdi-drag-horizontal-variant</v-icon>
                            {{ element.name }} ({{ element.area }} m²)

                            <div class="shortcut">
                                <v-icon v-if="!element.ignored" @click="ignoreBaseLayer(element)"
                                    class="pr-2">mdi-eye</v-icon>
                                <v-icon v-else @click="unIgnoreBaseLayer(element)" class="pr-2">mdi-eye-off</v-icon>

                                <v-icon @click="subtractLayer(element)" class="">mdi-arrow-down-circle-outline</v-icon>
                            </div>
                        </div>
                    </div>
                </div>
            </draggable>

        </div>

        <div class="col-12">
            <h3>
                Subtracted Layers
                <span class="headers-sum-text">(Sum: {{ subtractedLayersSum }}) </span>

            </h3>
            <draggable class="list-group subtracted-layers" :list="subtractedLayers" group="people" delayOnTouchOnly="true"
                delay="50" @change="log">
                <div v-for="(element, index) in subtractedLayers" :key="element.name">
                    <div :class="getClass(element)">
                        <div class="layer">
                            <v-icon class="pr-2">mdi-drag-horizontal-variant</v-icon>
                            {{ element.name }} ({{ element.area }} m²)
                            <div class="shortcut">
                                <v-icon v-if="!element.ignored" @click="ignoreSubtractedLayer(element)"
                                    class="pr-2">mdi-eye</v-icon>
                                <v-icon v-else @click="unIgnoreSubtractedLayer(element)" class="pr-2">mdi-eye-off</v-icon>
                                <v-icon @click="unSubtractLayer(element)">mdi-arrow-up-circle-outline</v-icon>
                            </div>
                        </div>
                    </div>
                </div>
            </draggable>

        </div>

        <div class="footer">
            <p>
                Area Sum <span class="sum-text">{{ totalAreaSum }}m² </span>
            </p>
        </div>
    </div>
</template>

<style scoped>
.subtracted-layers {
    min-height: 800px;
}

.hint {
    /* max-width: 400px; */
}

.shortcut {
    position: absolute;
    right: 0;
    top: 50%;
    margin-right: 16px;
    transform: translateY(-50%);
}

.row {
    padding: 16px;
}

.card {
    border-radius: 5px;
    box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.25);
    cursor: pointer;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 12px;
    margin: 12px;

    padding: 24px;
    height: auto;
    background-color: whitesmoke;

    border-radius: 0.5rem;
}

.list-group {
    max-width: 370px;
}

.footer {
    z-index: 4;
    position: fixed;
    left: 0;
    bottom: 0;
    padding-top: 12px;

    width: 100%;
    background-color: #0dd7b5;
    color: black;
    text-align: center;
}

.layer {
    display: flex;
    align-items: center;
}

.sum-text {
    font-size: 28px;
}

.headers-sum-text {
    color: #7f7979;
}
</style>
<script>
import draggable from "vuedraggable";

export default {
    name: "two-lists",
    display: "Two Lists",
    order: 4,
    delay: 50,
    components: {
        draggable,
    },
    data() {
        return {
            baseLayers: [
                {
                    id: 1,
                    name: "Front Yard",
                    area: 91.04,
                    ignored: false
                },
                {
                    id: 6,
                    name: "Garden Pond",
                    area: 10.44,
                    ignored: false
                },
                {
                    id: 7,
                    name: "Right Side Driveway",
                    area: 32.04,
                    ignored: false
                },
                // {
                //     id: 2,
                //     name: "Layer 2",
                //     area: 11.04
                // },
                // {
                //     id: 3,
                //     name: "Layer 3",
                //     area: 21.19
                // },
                // {
                //     id: 4,
                //     name: "Layer 4",
                //     area: 4.24
                // },
                // {
                //     id: 5,
                //     name: "Layer 5",
                //     area: 9.24
                // },
            ],
            subtractedLayers: [
                // {
                //     id: 6,
                //     name: "Garden Pond",
                //     area: 10.44,
                // },
                // {
                //     id: 7,
                //     name: "Right Side Driveway",
                //     area: 32.04,
                // },
                // {
                //     id: 8,
                //     name: "Another Layer",
                //     area: 2.04
                // },
                // {
                //     id: 9,
                //     name: "Yet Another Layer",
                //     area: 3.34
                // },
            ],
        };
    },
    created() {
        LiveChatWidget.call("hide");
    },
    computed: {
        baseLayersSum: function () {
            if (this.baseLayers.length < 1) {
                return 0;
            }
            let arr = this.baseLayers.filter(item => item.ignored == false);
            if (arr.length < 1) {
                return 0;
            }

            return parseFloat(arr.map((item) => item.area).reduce((prev, next) => prev + next)).toFixed(2);
        },
        subtractedLayersSum: function () {
            if (this.subtractedLayers.length < 1) {
                return 0;
            }
            let arr = this.subtractedLayers.filter(item => item.ignored == false);
            if (arr.length < 1) {
                return 0;
            }
            return parseFloat(arr
                .map((item) => item.area)
                .reduce((prev, next) => prev + next)).toFixed(2);
        },
        totalAreaSum() {
            // if (this.baseLayers.length < 1) {
            //     return 0;
            // }
            return parseFloat((this.baseLayersSum - this.subtractedLayersSum).toFixed(2));
        },
    },
    methods: {
        log: function (evt) {
            window.console.log(evt);
        },
        subtractLayer(layer) {
            this.subtractedLayers.push(layer);
            let index = this.baseLayers.findIndex((item) => item.id == layer.id);
            if (index > -1) {
                this.baseLayers.splice(index, 1);
            }
        },
        unSubtractLayer(layer) {
            this.baseLayers.push(layer);
            let index = this.subtractedLayers.findIndex((item) => item.id == layer.id);
            if (index > -1) {
                this.subtractedLayers.splice(index, 1);
            }
        },
        ignoreBaseLayer(layer) {
            let index = this.baseLayers.findIndex((item) => item.id == layer.id);
            console.log(this.baseLayers[index])
            this.baseLayers[index].ignored = true;
        },
        unIgnoreBaseLayer(layer) {
            let index = this.baseLayers.findIndex((item) => item.id == layer.id);
            console.log(this.baseLayers[index])
            this.baseLayers[index].ignored = false;
        },
        ignoreSubtractedLayer(layer) {
            let index = this.subtractedLayers.findIndex((item) => item.id == layer.id);
            console.log(this.subtractedLayers[index])
            this.subtractedLayers[index].ignored = true;
        },
        unIgnoreSubtractedLayer(layer) {
            let index = this.subtractedLayers.findIndex((item) => item.id == layer.id);
            console.log(this.subtractedLayers[index])
            this.subtractedLayers[index].ignored = false;
        },
        getClass(layer) {
            return (layer.ignored) ? 'list-group-item card grey lighten-1' : 'list-group-item card'
        }
    },
};
</script>
